export function ValidatePassword(password: string) {
    if (!password || password.length < 8) {
        return false;
    }
    return true;

    // // Regex to make sure it has at least one number in it 
    // var re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/

    // if (re.exec(password) == null) {
    //     return false;
    // }
    // return true;
}
export const ValidatePasswordMessage = "Password must be at least 8 characters long.";